import React from "react";
import { Button } from "reactstrap";
import { modalNamesFactory } from "../../Helper_functions/Languages/LanguageSelector";
import { exportToDocx } from "../../Helper_functions/files/WordExporter";
interface MarkdownDownloaderButtonProps {
  filename: string;
  content: string;
  id: number;
}

const MarkdownDownloaderButton: React.FC<MarkdownDownloaderButtonProps> = ({
  filename,
  content,
  id
}) => {
  const downloadMarkdown = () => {
    content =
      `<html xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:w="urn:schemas-microsoft-com:office:word"
          xmlns="http://www.w3.org/TR/REC-html40">` +
      content +
      "</html>";

      exportToDocx(content);
  };

  return (
    <Button onClick={downloadMarkdown} className="btn btn-success">
      {modalNamesFactory(id, "Personal Copy")||"Personal Copy"}
    </Button>
  );
};

export default MarkdownDownloaderButton;
